'use strict';

angular.module('ntmApp').factory('MonthlyRecurrence', ['Recurrence', 'Constants', function (Recurrence, Constants) {

    function MonthlyRecurrence() {
        Recurrence.call(this);

        var self = this;

        var DEFAULT_VALUES = {
            startsOnDate: new Date(moment().set('date', 1))
        };

        self.displaySchedulingLeeway = function () {
            return true;
        };

        self.displayOccurenceLimit = function () {
            return true;
        };

        self.displaySchedulingSettings = function () {
            return 'ng1/src/setup/recurrence/templates/scheduling-settings.html';
        };

        self.hideStartsOnDateBasedOnConditions = function () {
            return self.scheduleRacksOnDiffDays() && self.allowSetupRacks;
        };

        self.getSettingsTemplate = function () {
            return self.scheduleRacksOnDiffDays() ? 'ng1/src/setup/recurrence/templates/monthly-rack-settings.html' :
                                                    'ng1/src/setup/recurrence/templates/monthly-scheduling-settings.html';
        };

        self.getFieldsListForSave = function () {
            var fieldsList = self.getGeneralFieldsListForSave();

            if (self.scheduleRacksOnDiffDays()) {

                if (self.allowSetupRacks) {
                    fieldsList.scheduleRacksEveryMonthNumber = self.scheduleRacksEveryMonthNumber;
                    fieldsList.recurrenceRacks = getRackItemsFieldsForSave(self.rackItems);
                }
            } else {
                fieldsList.startsOnDate = self.startsOnDate;
                fieldsList.everyNumbersOfMonths = self.everyNumbersOfMonths;
                fieldsList.monthNumberMonthlyType = self.monthNumberMonthlyType;
                fieldsList.monthDayMonthlyType = self.monthDayMonthlyType;
            }

            fieldsList.beforeLeeway = self.beforeLeeway;
            fieldsList.afterLeeway = self.afterLeeway;

            return fieldsList;
        };

        self.getRequestData = function () {

            var request = self.getGeneralRequestData();

            if (self.scheduleRacksOnDiffDays()) {

                if (self.allowSetupRacks) {
                    request.everyMonthly = self.scheduleRacksEveryMonthNumber.value;
                    request.recurrenceRacks = getRackItemsRequestInfo(self.rackItems);
                }
            } else {
                request.dateStart = self.startsOnDate.value;
                request.everyMonthly = self.everyNumbersOfMonths;
                request.monthNumberMonthlyType = self.monthNumberMonthlyType.value;
                request.monthDayMonthlyType = self.monthDayMonthlyType.value;
            }

            request.beforeLeeway = self.beforeLeeway.value;
            request.afterLeeway = self.afterLeeway.value;

            return request;
        };

        self.applyDefaultInfo = function (data) {
            self.applyGeneralDefaultInfo(data);
        };

        self.setSpecificDefaultInfo = function () {
            if (!self.startsOnDate) {
                self.startsOnDate = { value: DEFAULT_VALUES.startsOnDate };
            } else if (self.startsOnDate && !self.startsOnDate.value) {
                self.startsOnDate.value = DEFAULT_VALUES.startsOnDate;
            }
        };

        self.setSpecificDefaultRackItemsInfo = function () {
            if (self.rackItems && self.rackItems.length && self.rackItems.length) {
                self.rackItems.forEach(function (rackItem) {
                    if (!rackItem.startsOnDate) {
                        rackItem.startsOnDate = { value: DEFAULT_VALUES.startsOnDate };
                    } else if (rackItem.startsOnDate && !rackItem.startsOnDate.value) {
                        rackItem.startsOnDate.value = DEFAULT_VALUES.startsOnDate;
                    }
                });
            }
        };

        self.checkForDynamicRestricts = function (field, fieldName) {

            switch (fieldName) {
                case 'startsOnDate':
                    field.restricts.allowNullable = false;

                    break;
                default:
                    break;
            }
        };

        self.equals = function (recurrence) {

            if (!self.compareGeneralInfo(recurrence)) {
                return false;
            }

            if (!self.areDaysEqual(self.startsOnDate.value, recurrence.startsOnDate.value)) {
                return false;
            }

            if (parseInt(self.beforeLeeway.value) !== parseInt(recurrence.beforeLeeway.value)) {
                return false;
            }

            if (parseInt(self.afterLeeway.value) !== parseInt(recurrence.afterLeeway.value)) {
                return false;
            }

            if (!self.areDaysEqual(self.occurenceLimitEndsOnDate.value, recurrence.occurenceLimitEndsOnDate.value)) {
                return false;
            }

            if (self.scheduleRacks !== recurrence.scheduleRacks) {
                return false;
            }

            if (self.scheduleRacksOnDiffDays()) {

                if (parseInt(self.scheduleRacksEveryMonthNumber.value) !== parseInt(recurrence.scheduleRacksEveryMonthNumber.value)) {
                    return false;
                }

                if (self.rackItems && recurrence.rackItems) {

                    for (var i = 0; i < self.rackItems.length; i++) {

                        if (parseInt(self.rackItems[i].monthlyDayPrefix.value) !== parseInt(recurrence.rackItems[i].monthlyDayPrefix.value)) {
                            return false;
                        }

                        if (parseInt(self.rackItems[i].monthlyDay.value) !== parseInt(recurrence.rackItems[i].monthlyDay.value)) {
                            return false;
                        }

                        if (!self.areDaysEqual(self.rackItems[i].startsOnDate.value, recurrence.rackItems[i].startsOnDate.value)) {
                            return false;
                        }

                    }
                }

            } else {

                if (parseInt(self.everyNumbersOfMonths) !== parseInt(recurrence.everyNumbersOfMonths)) {
                    return false;
                }

                if (parseInt(self.monthNumberMonthlyType.value) !== parseInt(recurrence.monthNumberMonthlyType.value)) {
                    return false;
                }

                if (parseInt(self.monthDayMonthlyType.value) !== parseInt(recurrence.monthDayMonthlyType.value)) {
                    return false;
                }
            }

            return true;
        };

        function getRackItemsFieldsForSave(rackItems) {

            if (rackItems) {
                return rackItems.map(function (item) {
                    var dateStartAndDateEndTemp = null;

                    if ((item.startsOnDate && item.startsOnDate.value) && (self.occurenceLimitEndsOnDate && self.occurenceLimitEndsOnDate.value)) {
                        dateStartAndDateEndTemp = [{ dateStart: item.startsOnDate, dateEnd: self.occurenceLimitEndsOnDate }];
                    }

                  return {
                        everyMonthly: item.everyNumbersOfDays,
                        monthNumberMonthlyType: item.monthlyDayPrefix,
                        monthDayMonthlyType: item.monthlyDay,
                        dateStart: item.startsOnDate,
                        dateStartAndDateEnd: dateStartAndDateEndTemp ? dateStartAndDateEndTemp : null
                    };
                });
            }

            return [];
        }

        function getRackItemsRequestInfo(rackItems) {

            if (rackItems) {
                return rackItems.map(function (item) {

                    return {
                        ccrackID: item.ccrackID,
                        rackId: item.rackId,
                        cageCount: item.cageCount,
                        monthNumberMonthlyType: parseInt(item.monthlyDayPrefix.value),
                        monthDayMonthlyType: parseInt(item.monthlyDay.value),
                        dateStart: item.startsOnDate.value
                    };
                });
            }

            return [];
        }

        function initialize() {
            self.patternType = Constants.Recurrence.Patterns.MONTHLY.value;
            self.datePickerOptions = { datepickerMode: 'month', minMode: 'month', templateString: 'MMMM, y' };
        }

        initialize();
    }

    MonthlyRecurrence.prototype = Object.create(Recurrence.prototype);
    MonthlyRecurrence.prototype.constructor = Recurrence;

    return (MonthlyRecurrence);

}]);
